const state = {
	curProfileTab: 'basic'
}
const mutations = {
	setProfileTab(state, data) {
		state.curProfileTab = data
	}
}

export default {
	state,
	mutations
}
